import AppDispatcher from './AppDispatcher';

export default AppDispatcher;
